// directives/acss.ts
import { ASS } from "@adornis/ass/index";
import { logger } from "@adornis/base/logging";
import { nothing } from "lit";
import { AsyncDirective } from "lit/async-directive.js";
import { directive } from "lit/directive.js";
import { ChemistryLitElement } from "../chemistry-lit-element";
var ASSDirective = class extends AsyncDirective {
  constructor(_partInfo) {
    super(_partInfo);
    this._partInfo = _partInfo;
    this._element = _partInfo.element;
  }
  get _host() {
    return this._partInfo.options?.host;
  }
  get sheet() {
    return this._sheet;
  }
  update(part, [styleInfo]) {
    this._updateStyles(part, styleInfo);
    return nothing;
  }
  render(_ref) {
    return nothing;
  }
  _updateStyles(part, styleInfo) {
    if (!this._host || !(this._host instanceof ChemistryLitElement)) {
      logger.error(
        { host: this._host, element: this._element, root: this._element.getRootNode() },
        "acss directive can only be used in ChemistryLitElements"
      );
      throw new Error("acss directive can only be used in ChemistryLitElements");
    }
    if (Object.keys(styleInfo ?? {}).length) {
      const oldASS = this._ass;
      this._ass = ASS.makeSheet(styleInfo, true, this._element.nodeName.toLowerCase());
      this._sheet = this._ass.toSheet();
      if (oldASS) {
        this._element.classList.remove(oldASS.className);
        if (oldASS !== this._ass)
          this._removeSheetFromHost(oldASS);
      }
      this._element.classList.add(this._ass.className);
      if (!this._host.inlineStyleParts.has(this))
        this._host.inlineStyleParts.add(this);
    }
  }
  reconnected() {
    if (!this._sheet || !this._host)
      return;
    if (!this._host.inlineStyleParts.has(this))
      this._host.inlineStyleParts.add(this);
  }
  disconnected() {
    if (!this._sheet || !this._host)
      return;
    if (this._ass)
      this._removeSheetFromHost(this._ass);
  }
  _removeSheetFromHost(ass) {
    if (!this._host)
      throw new Error("Cannot remove sheet from host without host");
    this._host.inlineStyleParts.delete(this);
    this._element.classList.remove(ass.className);
  }
};
var acss = directive(ASSDirective);
export {
  ASSDirective,
  acss
};
